import i18n from '@buy-viasat/utils/src/lib/config/i18n';
import serviceabilityEnUS from './locales/en-US/serviceability.json';
import commonEnUS from './locales/en-US/common.json';

i18n.addResourceBundle('en-US', 'serviceability', serviceabilityEnUS);
i18n.addResourceBundle('en-US', 'beamCommon', commonEnUS, true, true);

export default i18n;
